<div class="row pagination-controller" style="margin:0">
	<div class="col">
		<div class="input-group input-group-sm">
			<label for="pageSize" class="input-group-text"><i class="fa fa-eye" style="color: var(--bs-bg-servicios)"></i></label>
			<select name="pageSize" [(ngModel)]="elements.size" (change)="changePageSize()" id="pageSize" class="form-select">
				<option *ngFor="let val of sizes" [ngValue]="val">{{val}}</option>
			</select>
		</div>
	</div>
	<div class="col info-controller">
		<span>{{elements.start}} - {{elements.end}} de {{elements.total}}</span>
	</div>
	<div class="col controls">
		<i class="fa fa-angles-left" [ngClass]="elements.page==0?'inactive':'active'" (click)="start()"></i>
		<i class="fa fa-chevron-left" [ngClass]="elements.page==0?'inactive':'active'" (click)="previous()"></i>
		<i class="fa fa-chevron-right" [ngClass]="isOnLastPage()?'inactive':'active'" (click)="next()"></i>
		<i class="fa fa-angles-right" [ngClass]="isOnLastPage()?'inactive':'active'" (click)="last()"></i>
	</div>
</div>